__turbopack_context__.v({
  "control-elements": "PriceHistoryElement-module-scss-module__66Ff9W__control-elements",
  "graph": "PriceHistoryElement-module-scss-module__66Ff9W__graph",
  "period-btn": "PriceHistoryElement-module-scss-module__66Ff9W__period-btn",
  "period-dropdown": "PriceHistoryElement-module-scss-module__66Ff9W__period-dropdown",
  "period-selection": "PriceHistoryElement-module-scss-module__66Ff9W__period-selection",
  "toggle": "PriceHistoryElement-module-scss-module__66Ff9W__toggle",
});
